<template>
    <v-app>
        <v-container class="services">
            <v-layout xs8 md12 row wrap class="title-block">
                <services-breadcrumbs v-if="b2b"></services-breadcrumbs>
                <v-flex>
                    <h2>Бесплатное оформление договора купли-продажи</h2>
                </v-flex>
            </v-layout>
            <services-carousel
                v-if="!b2b"
                :slides="carouselSlides"
            />
        </v-container>
        <v-form ref="form" class="pb-5">
            <v-container class="services">
                <v-layout wrap row>
                    <v-flex md6 lg4 hidden-sm-and-down>
                        <v-checkbox
                            v-model="ownerIsNotBuyer"
                            label="Продавец не является собственником ТС и действует по нотариальной доверенности."
                            class="mt-0"
                        />
                    </v-flex>
                    <v-flex xs12 offset-md2 md4 offset-lg5 lg3 class="download-menu">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                color="primary"
                                class="button next-button"
                                v-on="on"
                                >
                                    Скачать пустой бланк
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile
                                    @click=""
                                >
                                    <v-list-tile-title>
                                        <a :href="'/downloads/DKP.doc'" target="_blank">Обычный</a>
                                    </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile
                                    @click=""
                                >
                                    <v-list-tile-title>
                                        <a :href="'/downloads/DKPWithLetterOfAttorney.doc'" target="_blank">С доверенностью</a>
                                    </v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 hidden-md-and-up>
                        <v-checkbox
                            v-model="ownerIsNotBuyer"
                            label="Продавец не является собственником ТС и действует по нотариальной доверенности."
                            class="mt-0"
                        />
                    </v-flex>
                </v-layout>
                <v-layout wrap row>
                    <v-flex xs12 md6 py-0>
                        <v-text-field
                            label="Место составления"
                            v-model="location"
                        />
                    </v-flex>
                    <v-flex xs12 md6 py-0>
                        <osago-date
                            label="Дата составления"
                            v-model="fillDate"
                            :max="dateToday"
                            :isHideMobile="true"
                        />
                    </v-flex>
                </v-layout>
            </v-container>
            <service-transport-form
                :value="transport"
            />
            <service-person-form
                v-if="ownerIsNotBuyer"
                title="Собственник транспортного средства"
                :person="owner"
            />
            <service-person-form
                title="Продавец транспортного средства"
                :person="seller"
                :ownerIsNotBuyer="ownerIsNotBuyer"
            />
            <service-person-form
                title="Покупатель транспортного средства"
                :person="buyer"
            />
            <v-container class="services">
                <v-layout wrap row>
                    <v-flex xs12 md6 py-0>
                        <v-text-field
                            v-model="sum"
                            :rules="[rules.required, rules.numbers]"
                            label="Сумма"
                            required
                        />
                    </v-flex>
                    <v-flex xs12 md6 py-0>
                        <v-select
                            v-model="currency"
                            :items="currencies"
                            label="Валюта"
                            single-line
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex>
                        <v-text-field
                            v-model="additionalConditions"
                            label="Доп. условия"
                            required
                        />
                        </v-flex>
                </v-layout>
            </v-container>
            <v-container class="services">
                <v-layout
                    class="service-form-button"
                >
                    <v-btn @click="download"
                        class="button next-button block"
                        :loading="this.loading"
                    >
                        Скачать PDF
                    </v-btn>
                </v-layout>
                </v-container>
        </v-form>
        <services-underlist v-if="!b2b" />
        <services-list v-if="!b2b" />
    </v-app>
</template>
<script>
    import moment from 'moment';
    import ServicesBreadcrumbs from "./ServicesBreadcrumbs";

    export default {
        components: {'services-breadcrumbs': ServicesBreadcrumbs},
        props: {
            b2b: {
                default: false
            }
        },
        data: () => ({
            loading: false,
            carouselSlides: [
                'Оформите юридически точный ДКП всего за 5 минут.',
                'Автоматически заполним данные об автомобиле.',
                'Рассчитайте ОСАГО всего в пару кликов.'
            ],
            ownerIsNotBuyer: false,
            sum: null,
            currency: 'Руб.',
            additionalConditions: null,
            location: null,
            fillDate: null,
            dateToday: null,
            currencies: ['Руб.', 'Доллар США', 'Евро'],

            owner: {
                role: 'owner',
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false
                },
                birthday: null,
                passport: {
                    seriesNumber: null,
                    date: null,
                    issuedBy: null
                },
                address: null,
            },
            seller: {
                role: 'seller',
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false
                },
                birthday: null,
                passport: {
                    seriesNumber: null,
                    date: null,
                    issuedBy: null
                },
                address: null,
                procuratory: {
                    fio: null,
                    number: null,
                    date: null
                }
            },
            buyer: {
                role: 'buyer',
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false
                },
                birthday: null,
                passport: {
                    seriesNumber: null,
                    date: null,
                    issuedBy: null
                },
                address: null,
            },
            transport: {
                category: 'B',
                mark: null,
                model: null,
                noVin: false,
                noBodyNumber: false,
                noChassisNumber: false,
                vin: null,
                bodyNumber: null,
                chassisNumber: null,
                licensePlate: null,
                yearIssue: null,
                color: null,
                engine: null,
                type: 'Легковой',
                isSrtsAndLicensePlate: false,
                pts: {
                    location: null,
                    seriesNumber: null,
                    date: null,
                },
                sts: {
                    location: null,
                    seriesNumber: null,
                    date: null,
                }
            },
            rules: {
                required: v => !!v || 'Обязательное поле',
                numbers: v => /^[АВЕКМНОРСТУХ_\d\s]*$/.test(v) || 'Неверный формат',
            }
        }),
        created: function(){
            this.dateToday = this.fillDate = moment().format('YYYY-MM-DD')
        },
        methods: {
            download() {
                axios.post(
                    '/services/getpdf',
                    {
                        location: this.location,
                        date: this.fillDate,
                        sum: this.sum,
                        currency: this.currency,
                        additionalConditions: this.additionalConditions,
                        owner: this.owner,
                        seller: this.seller,
                        buyer: this.buyer,
                        transport: this.transport,
                        ownerIsNotBuyer: this.ownerIsNotBuyer
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/pdf'
                        },
                        responseType: "blob"
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'file.pdf');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error)
                })
            }
        }
    }
</script>

<style>
    .download-menu .v-btn {
        outline: none;
    }

    .download-menu .v-btn__content, .service-form-button .v-btn__content {
        white-space: nowrap !important;
    }

    .v-menu__content .v-list__tile__title a {
        color: #00ba57 !important;
    }

    .v-select-list .v-list__tile--link {
        color: #000 !important;
    }
    .v-select-list .v-list__tile--active {
        color: #00ba57 !important;
    }

</style>



// WEBPACK FOOTER //
// resources/js/components/services/ServiceSalesContractPage.vue